<template>
  <div></div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/AuthStore.js';

const handleRoute = async () => {
  const router = useRouter();
  const searchParams = new URLSearchParams(window.location.search);
  const code = searchParams.get('code');
  if (!code || !(await useAuthStore().authenticateCode(code))) {
    router.replace('/login');
    return;
  }

  const ret = searchParams.get('ret');

  if (ret) {
    router.replace('/' + ret);
    return;
  }
  router.replace('/');
};

onMounted(async () => {
  handleRoute();
});
</script>
